export default __webpack_public_path__ + "static/media/img1.21bc7a55.png";